export default __webpack_public_path__ + "static/media/chevron-up-solid.79f87285.svg";